module.exports = __webpack_public_path__ + "img/community.3e94018b.webp";